module.exports = __webpack_public_path__ + "static/img/student.5c9c1436.png";